import { useState } from "react";
import GetTime from "../../utils/gettime";
import GetDate from "../../utils/getdate";

export default function EventBoxContent({ item, detail }) {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="sm:p-4 p-2.5 border-t border-gray-100 font-normal space-y-3 relative dark:border-slate-700/40">
      {item.e_amount !== "" && item.e_amount > 0 && (
        <div style={{ fontSize: 18 }}>
          Registration Fees : <span style={{ fontWeight: 600 }}>₹{item.e_amount}.00</span>
        </div>
      )}

      {detail && (
        <div className="space-y-3">
          <div className="flex">
            <div>
              Start <br />
              {GetDate(item.e_start)}
            </div>
            <div className="ml-auto">
              End <br />
              {GetDate(item.e_end)}
            </div>
          </div>
          <div>
            Last date to apply <br />
            {GetDate(item.e_lastDate)}
          </div>
          <div className="flex">
            <i className="fa fa-map-marker"></i>&nbsp;{item.e_address}
          </div>
        </div>
      )}

      {/* Description section with clamp and toggle */}
      <div>
        <p className={!isExpanded ? "line-clamp-2" : ""}>
          {item.e_desc}
        </p>

        {item.e_desc && item.e_desc.length > 100 && (
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="text-blue-600 hover:underline font-medium text-sm mt-1 focus:outline-none"
          >
            {isExpanded ? "Show Less" : "More..."}
          </button>
        )}
      </div>
    </div>
  );
}